import type { AppRouteObject } from "../../routes";
import { StylesRoute, StylesRouteWithTab } from "./routes/Styles";

const routes: AppRouteObject[] = [StylesRoute, StylesRouteWithTab];

export default routes;
